// eslint-disable-next-line import/no-unresolved
import {lazy} from 'react';

const ROUTES = [
  {
    path: '/dashboard',
    exact: true,
    component: lazy(() => import('../pages/dashboard')),
    name: 'Home',
    isPrivate: true,
  },
  {
    path: '/',
    exact: true,
    component: lazy(() => import('./RootRedirect')),
    name: 'RootRedirect',
    isPrivate: false,
  },
  {
    path: '/login',
    exact: true,
    component: lazy(() => import('../pages/auth/container/login')),
    name: 'Login',
    isPrivate: false,
  },
  {
    path: '/reset-password',
    exact: true,
    component: lazy(() => import('../pages/auth/new-password')),
    name: 'NewPassword',
    isPrivate: false,
  },
  {
    path: '/rules',
    exact: true,
    component: lazy(() => import('../pages/rules')),
    name: 'Rules',
    isPrivate: true,
  },
  {
    path: '/rules/:workflowId',
    exact: true,
    component: lazy(() => import('../pages/rule-detail')),
    name: 'RuleDetail',
    isPrivate: true,
  },
  {
    path: '/lookups/:lookupId/versions',
    exact: true,
    component: lazy(() => import('../pages/lookups/version-history')),
    name: 'LookupVersionHistory',
    isPrivate: true,
  },
  {
    path: '/lookups/:lookupId',
    exact: true,
    component: lazy(() => import('../pages/lookups/lookup-builder')),
    name: 'LookupBuilder',
    isPrivate: true,
  },
  {
    path: '/lookups',
    exact: true,
    component: lazy(() => import('../pages/lookups')),
    name: 'Lookups',
    isPrivate: true,
  },
  {
    path: '/execution-monitor',
    exact: true,
    component: lazy(() => import('../pages/execution-monitor')),
    name: 'ExecutionMonitor',
    isPrivate: true,
  },
  {
    path: '/execution-monitor/executions/:executionId',
    exact: true,
    component: lazy(
      () => import('../pages/execution-monitor/execution-detail')
    ),
    name: 'ExecutionDetail',
    isPrivate: true,
  },
  {
    path: '/execution-monitor/workflows/:workflowId',
    exact: true,
    component: lazy(() => import('../pages/execution-monitor/workflow-detail')),
    name: 'WorkflowExecutionConfiguration',
    isPrivate: true,
  },
  {
    path: '/integrations',
    exact: true,
    component: lazy(
      () => import('../pages/integrations/IntegrationsDisabledRedirect')
    ),
    name: 'Integrations',
    isPrivate: true,
  },
  {
    path: '/integrations/create',
    exact: true,
    component: lazy(
      () => import('../pages/integrations/IntegrationsDisabledRedirect')
    ),
    name: 'CreateIntegration',
    isPrivate: true,
  },
  {
    path: '/integrations/create/database',
    exact: true,
    component: lazy(
      () => import('../pages/integrations/IntegrationsDisabledRedirect')
    ),
    name: 'ConfigureDatabaseIntegration',
    isPrivate: true,
  },
  {
    path: '/integrations/configure/:id',
    exact: true,
    component: lazy(
      () => import('../pages/integrations/IntegrationsDisabledRedirect')
    ),
    name: 'ConfigureDatabaseIntegrationEdit',
    isPrivate: true,
  },
  {
    path: '/cases',
    exact: true,
    component: lazy(() => import('../pages/cases')),
    name: 'Cases',
    isPrivate: true,
  },
  {
    path: '/cases/:caseId',
    exact: true,
    component: lazy(() => import('../pages/case-detail')),
    name: 'CaseDetail',
    isPrivate: true,
  },
  {
    path: '/workflow-simulator/:id',
    exact: true,
    component: lazy(() => import('../pages/loan-simulator')),
    name: 'LoanSimulator',
    isPrivate: true,
  },
];

export default ROUTES;
